import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setServiceUrl,
} from '@library/http/requests'
import { ErrorResponse } from '@library/http/src/parsers/errors'

export type CmsReadBrokerRecipe = {
  url: string
  title: string
  gousto_id: string
  gousto_uid: string
}

export type CmsReadBrokerResponse = {
  status: string
  data: { entry: CmsReadBrokerRecipe }
}

export async function parseCmsReadBrokerResponse(
  response: Response,
): Promise<CmsReadBrokerResponse> {
  if (!response.ok) {
    throw new ErrorResponse(response)
  }

  const parsedJSON = JSON.parse(await response.text())

  const result = parsedJSON as Record<string, unknown>

  return result as CmsReadBrokerResponse
}

const request = composeRequest(
  setServiceUrl('cmsreadbroker', 1),
  addPath((coreRecipeId: string | number) => `recipe-by-id/${coreRecipeId}`),
  setMethod('GET'),
  goustoHeaders,
)

export const getCmsRecipeById = composeFetch(request, parseCmsReadBrokerResponse)
